/**
 * 意见反馈 - API 路由定义
 *
 * @module api/feedback/routes
 * @author AI Assistant
 * @version 2.0.0
 * @since 2026-01-21
 */

import { API_V1_ROUTES } from '../routes/v1'

/**
 * 意见反馈 API 路由前缀
 */
export const FEEDBACK_API_PREFIX = API_V1_ROUTES.feedback.list

/**
 * 意见反馈 API 路由定义
 */
export const FEEDBACK_ROUTES = {
  /** 获取反馈类型列表 */
  types: API_V1_ROUTES.feedback.types,
  /** 获取反馈状态列表 */
  statuses: API_V1_ROUTES.feedback.statuses,
  /** 获取我的反馈列表（App 端） */
  my: API_V1_ROUTES.feedback.my,
  /** 获取我的反馈详情（App 端用户只能查看自己的） */
  myDetail: API_V1_ROUTES.feedback.myDetail,
  /** 用户追问（App 端用户添加评论） */
  myComment: API_V1_ROUTES.feedback.myComment,
  /** 用户确认解决（App 端） */
  myResolve: API_V1_ROUTES.feedback.myResolve,
  /** 获取统计信息 */
  statistics: API_V1_ROUTES.feedback.statistics,
  /** 获取反馈列表（Web 端管理） */
  list: FEEDBACK_API_PREFIX,
  /** 创建反馈 */
  create: FEEDBACK_API_PREFIX,
  /** 获取反馈详情（含评论列表） */
  detail: API_V1_ROUTES.feedback.detail,
  /** 获取反馈评论列表 */
  comments: API_V1_ROUTES.feedback.comments,
  /** 管理员回复反馈（添加评论） */
  reply: API_V1_ROUTES.feedback.reply,
  /** 更新反馈状态 */
  updateStatus: API_V1_ROUTES.feedback.updateStatus,
  /** 删除反馈 */
  delete: API_V1_ROUTES.feedback.delete,
} as const
